import "../css/header.scss";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";

function Header() {
  const { cartItems } = useContext(CartContext);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <header className="site-header" role="banner">
      <div className="header-top">
        <span>
          CATALOGUE PREVIEW — ONLINE PAYMENT IS NOT CURRENTLY ENABLED.
        </span>
      </div>
      <div className="header-main">
        <nav className="header-nav">
          <Link onClick={toTop} to="/shop" className="nav-link">
            SHOP ALL
          </Link>

          <Link onClick={toTop} to="/about" className="nav-link">
            ABOUT US
          </Link>
          <Link onClick={toTop} to="/contact" className="nav-link">
            CONTACT
          </Link>
        </nav>
        <Link onClick={toTop} to="/" className="header-logo">
          Uightparcel
        </Link>
        <div className="header-actions">
          <Link onClick={toTop} to="/cartpage" className="action-btn cart-btn">
            SELECTION <span className="cart-count">({cartItems.length})</span>
          </Link>
        </div>
      </div>
    </header>
  );
}

export default Header;
